import { render, staticRenderFns } from "./FormatMoney.vue?vue&type=template&id=42e6554c&scoped=true&"
import script from "./FormatMoney.vue?vue&type=script&lang=ts&"
export * from "./FormatMoney.vue?vue&type=script&lang=ts&"
import style0 from "./FormatMoney.vue?vue&type=style&index=0&id=42e6554c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e6554c",
  null
  
)

export default component.exports